import { Injectable } from '@angular/core';
import {BaseDatabaseService} from '../BaseDatabaseService';
import {SportType} from '../../../classes/SportType';

@Injectable({
  providedIn: 'root'
})
export class SportTypesService extends BaseDatabaseService{

  private collectionName = "sportTypes";

  constructor() {
    super();
  }

  getSportTypes() {
    return this.db.collection(this.collectionName).get();
  }

  getOneSportType(key) {
    return this.db.collection(this.collectionName).doc(key).get();
  }

  createSport(id, sport: SportType){
    sport.category = sport.category.map(item => Object.assign({}, item));
    const obj = {
      type: sport.type,
      category: sport.category
    };
    return this.db.collection(this.collectionName).doc(id).set(obj);
  }

  deleteSport(id) {
    return this.db.collection(this.collectionName).doc(id).delete();
  }
}
